module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/asset/create-asset/create-asset.component.css
// module id = ./src/app/components/asset/create-asset/create-asset.component.css
// module chunks = main